import { PaginationModel, SortModel } from "@spartacus/core";

export interface AllowedPermission {
  uid?: string;
  label?: string;
}

export interface AllowedPermissionOrMouseEvent extends AllowedPermission {
  target?: EventTarget | null
}

export interface AccessSubject {
  allowedPermissions?: AllowedPermission[];
  code?: string;
  multiplePermissions?: boolean;
  name?: string;
  order?: number;
}

export interface AccessSubjectList {
  ringfotoAccessSubjects?: AccessSubject[];
  pagination?: PaginationModel;
  sorts?: SortModel[];
}

export interface NormalizedAccessSubject {
  code?: string;
  name?: string;
  order?: number;
  multiplePermissions?: boolean;
  allowedPermissionCode?: string;
  allowedPermissionLabel?: string;
}

export enum AccessSubjectFunctionalKeys {
  SUI_GENERIS_PERMISSION = 'suiGenerisPermission'
}
